import React, { useState, useContext, useEffect } from "react";
import globalComp from "../../../global/components";
import textTools from "./TextTools";
import imageTools from "./ImageTools";
import ff, { commonStyle } from "../../../util/fabric";
import { CanvasContext, ModuleContext, ImageContext } from "../provider";
let config = require("../../../../appConfig.json");

function TextLogo_Prd(): JSX.Element {
  let t = window.INITIAL_DATA.TRANSLATIONS;
  const { moduleImages, moduleInfo, setModuleInfo } = useContext(ModuleContext);
  const { canvasRef, scaledCanvasSize } = useContext(CanvasContext);
  const { initDropZone } = useContext(ImageContext);

  const [quote, setQuote] = useState<string>(t.kids_module_default_quote);

  useEffect(() => {
    let url = "https://storage.googleapis.com/papername-bucket";
    setModuleInfo({
      ...moduleInfo,
      ...commonStyle,
      fontFamily:
        window.INITIAL_DATA.LANGUAGE == "ru"
          ? config.cyrillicFonts[0]
          : config.latinFonts[0],
      preset: {
        texts: [window.INITIAL_DATA.TRANSLATIONS.type_your_text_here],
        images: [
          {
            originalUrl: `${url}/presets/picture.png`,
            filteredUrl: `${url}/presets/picture.png`,
            croppedUrl: `${url}/presets/picture.png`,
            renderUrl: `${url}/presets/picture.png`,
            wcIdFiltered: 0,
            wcIdOriginal: 0,
          },
        ],
      },
    });
    initDropZone();
  }, []);

  useEffect(() => {
    if (canvasRef.current && scaledCanvasSize) {
      if (!canvasRef.current.getObjects().length) {
        ff.addTextLogoPreset(
          canvasRef.current,
          quote,
          moduleInfo.preset.images[0].renderUrl
        );
      }
    }
  }, [canvasRef.current, scaledCanvasSize]);

  useEffect(() => {
    if (canvasRef.current) {
      ff.editTextById(canvasRef.current, "quote", quote);
    }
  }, [quote]);

  useEffect(() => {
    if (moduleImages) {
      ff.handleTextLogo_ImageChange(moduleImages, canvasRef.current);
    }
  }, [moduleImages, scaledCanvasSize]);

  function handleQuoteChange(word: string) {
    if (
      (word.length < 100 &&
        word.match(/^[^\udf00-\udfff\udc00-\ude4f\ude80-\udeff]+$/)) ||
      word == ""
    ) {
      setQuote(word);
    }
  }
  return (
    <>
      <textTools.FontFamily number={1} />
      <textTools.ColorCombination
        number={2}
        radioGroupName={"color-preset-input"}
      />
      <globalComp.TextBox
        number={3}
        labelStr={t.enter_your_quote}
        tooltipStr={t.tooltip_enter_your_quote}
        placeholderStr={t.enter_your_quote_placeholder}
        type={"textarea"}
        onChange={(event) => {
          // @ts-ignore
          handleQuoteChange(event.target.value);
        }}
        onFocus={(event) => {
          if (event.target.value == t.kids_module_default_quote) {
            event.target.value = "";
          }
        }}
        value={quote}
        maxStrLength={100}
      />
      <imageTools.ImageUploader number={4} />
    </>
  );
}

export default TextLogo_Prd;
